export const dependencies = {
    "firebase": "FIREBASE_VERSION"
};

export const devDependencies = {
    "@angular-devkit/architect": "ANGULAR_DEVKIT_ARCH_VERSION",
    "firebase-tools": "FIREBASE_TOOLS_VERSION",
    "fuzzy": "FUZZY_VERSION",
    "inquirer": "INQUIRER_VERSION",
    "inquirer-autocomplete-prompt": "INQUIRER_AUTOCOMPLETE_VERSION"
};